// extracted by mini-css-extract-plugin
module.exports = {"tradeupTips":"YQ9n90O2","wrap":"CMJ80J_U","close":"_bbVvblM"};